import { render, staticRenderFns } from "./GiftPay.vue?vue&type=template&id=2aed77ad&"
import script from "./GiftPay.vue?vue&type=script&lang=js&"
export * from "./GiftPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports